<script lang="ts">
	import { companyValuesId } from "@core/schema/ids/companyValuesId.js";
	import { getInquiryPath } from "@core/schema/paths/getInquiryPath.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./CompanyValues.translations.json" with { type: "json" };
	import Formatted from "./common/Formatted.svelte";
	import Link from "./common/Link.svelte";
	import StickySection from "./common/StickySection.svelte";
	import TextWithIcon from "./common/TextWithIcon.svelte";
	import { ButtonVariant } from "./common/getButtonClass.js";

	const { tenant } = getGlobalTemplateProps();
	const translate = getTranslate(translations);
</script>

<section class="full-width grid-container" id={companyValuesId[tenant.locale]}>
	<div class="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-20">
		<div class="flex order-2 lg:order-1 flex-col gap-8 lg:gap-6">
			<div class="flex flex-col md:gap-16 p-4 md:p-6 rounded-2xl bg-zms-grey">
				<div class="text-zms-blue text-3xl/[1] font-hubot font-light tracking-[-1%]">1</div>
				<div class="flex flex-col gap-6">
					<h3 class="text-zms-blue-dark md:text-[2rem]/[1] text-[1.6rem]/[1.2] font-medium tracking-[-1%]">
						<Formatted text={translate("value1Title")} />
					</h3>
					<p class="text-optical-black text-[1.125rem]/[1.4] font-normal">
						<Formatted text={translate("value1Description")} />
					</p>
				</div>
			</div>
			<div class="flex flex-col md:gap-16 p-4 md:p-6 rounded-2xl bg-zms-grey">
				<div class="text-zms-blue text-3xl/[1] font-hubot font-light tracking-[-1%]">2</div>
				<div class="flex flex-col gap-6">
					<h3 class="text-zms-blue-dark md:text-[2rem]/[1] text-[1.6rem]/[1.2] font-medium tracking-[-1%]">
						<Formatted text={translate("value2Title")} />
					</h3>
					<p class="text-optical-black text-[1.125rem]/[1.4] font-normal">
						<Formatted text={translate("value2Description")} />
					</p>
				</div>
			</div>
			<div class="flex flex-col md:gap-16 p-4 md:p-6 rounded-2xl bg-zms-grey">
				<div class="text-zms-blue text-3xl/[1] font-hubot font-light tracking-[-1%]">3</div>
				<div class="flex flex-col gap-6">
					<h3 class="text-zms-blue-dark md:text-[2rem]/[1] text-[1.6rem]/[1.2] font-medium tracking-[-1%]">
						<Formatted text={translate("value3Title")} />
					</h3>
					<p class="text-optical-black text-[1.125rem]/[1.4] font-normal">
						<Formatted text={translate("value3Description")} />
					</p>
				</div>
			</div>
			<div class="flex flex-col md:gap-16 p-4 md:p-6 rounded-2xl bg-zms-grey">
				<div class="text-zms-blue text-3xl/[1] font-hubot font-light tracking-[-1%]">4</div>
				<div class="flex flex-col gap-6">
					<h3 class="text-zms-blue-dark md:text-[2rem]/[1] text-[1.6rem]/[1.2] font-medium tracking-[-1%]">
						<Formatted text={translate("value4Title")} />
					</h3>
					<p class="text-optical-black text-[1.125rem]/[1.4] font-normal">
						<Formatted text={translate("value4Description")} />
					</p>
				</div>
			</div>
		</div>
		<div class="flex order-1 lg:order-2 flex-col gap-6 lg:gap-10 lg:text-end text-start lg:items-end items-start">
			<StickySection>
				<h2>
					<Formatted text={translate("heading")} />
				</h2>

				<div class="flex flex-col gap-10 md:gap-16 mt-4 md:mt-8">
					<p class="font-normal md:text-lg/[1.4] text-optical-black flex flex-col gap-6 h-full">
						<span><Formatted text={translate("subheading")} /></span>
					</p>
					<div>
						<Link href={getInquiryPath(tenant)} variant={ButtonVariant.OutlinedWithIcon}>
							<TextWithIcon>
								<Formatted text={translate("contactButtonText")} />
							</TextWithIcon>
						</Link>
					</div>
				</div>
			</StickySection>
		</div>
	</div>
</section>
